import type { I18nProvider } from './types';

let resolver: (() => I18nProvider) | null = null;

/**
 * Register the per-app i18n provider. Call once during app boot, before
 * any shared component renders. The resolver is invoked lazily so it can
 * call a Pinia store (which requires an active Pinia instance).
 *
 * @example
 *   // apps/ui/src/boot/i18n.ts
 *   setI18nProvider(() => useI18nStore());
 */
export function setI18nProvider(provider: () => I18nProvider): void {
  resolver = provider;
}

/**
 * Resolve the registered i18n provider. Used by shared components.
 * Throws if no provider has been registered — surface the wiring bug
 * loudly rather than silently rendering raw translation keys.
 */
export function useSharedI18n(): I18nProvider {
  if (!resolver) {
    throw new Error(
      '[shared/i18n] No i18n provider registered. Call setI18nProvider() in your app boot.',
    );
  }
  return resolver();
}
